<template>
  <section id="Categoria" class="categorias">
    <h2 class="titulo">📚 Categorías</h2>

    <div class="grid-categorias">
      <div
        v-for="(categoria, index) in categorias"
        :key="index"
        class="card-categoria"
      >
        <img :src="categoria.icono" :alt="categoria.titulo" class="icono" />
        <h3 class="card-titulo">{{ categoria.titulo }}</h3>
        <p class="card-descripcion">{{ categoria.descripcion }}</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CategoriasComputacion',
 data() {
  return {
    categorias: [
      {
        titulo: 'Windows',
        icono: require('@/assets/icons/windows.svg'),
        descripcion: 'Soluciones, configuraciones y optimización para el sistema operativo más usado en entornos de oficina y hogar.'
      },
      {
        titulo: 'Linux',
        icono: require('@/assets/icons/Linux.png'),
        descripcion: 'Guías para distros como Ubuntu, Debian y Arch. Ideal para usuarios técnicos y entornos de desarrollo.'
      },
      {
  titulo: 'macOS',
  icono: require('@/assets/icons/macos.png'),
  descripcion: 'Guías, configuraciones y soluciones para usuarios de macOS. Ideal para entornos creativos, desarrollo y productividad en equipos Apple.'
},
      {
        titulo: 'Microsoft Office',
        icono: require('@/assets/icons/office.png'),
        descripcion: 'Tutoriales y tips para Word, Excel, PowerPoint y otras herramientas de productividad de Microsoft.'
      },
{
  titulo: 'Software Profesional',
  icono: require('@/assets/icons/adobe-suite.png'), 
  descripcion: 'Suite Adobe para diseño gráfico, edición de video, animación, maquetación editorial y producción multimedia profesional.'
},
{
  titulo: 'Antivirus',
  icono: require('@/assets/icons/antivirus-suite.png'),
  descripcion: 'Soluciones de seguridad digital como Norton, Avast, Kaspersky y más, para proteger tus dispositivos contra amenazas y malware.'
},
    ]
  }
}

}
</script>

<style scoped>
.categorias {
  background: url('@/assets/Img/Banners/computacion.jpg') no-repeat center center;
  background-size: cover;
  padding: 3rem 2rem;
  color: #fff;
  text-align: center;
}

.titulo {
  font-size: 2.5rem;
  margin-bottom: 2rem;
  font-weight: bold;
  color: #ffffff;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.4);
  animation: fadeInDown 1s ease-in-out;
}

.grid-categorias {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(260px, 1fr));
  gap: 2rem;
  max-width: 1200px;
  margin: auto;
}

.card-categoria {
  background-color: rgba(255, 255, 255, 0.95);
  border-radius: 16px;
  padding: 1.5rem;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.15);
  transition: transform 0.4s ease, box-shadow 0.4s ease;
  color: #333;
  display: flex;
  flex-direction: column;
  align-items: center;
  opacity: 0;
  animation: fadeInUp 1s ease forwards;
}

.card-categoria:nth-child(1) { animation-delay: 0.1s; }
.card-categoria:nth-child(2) { animation-delay: 0.2s; }
.card-categoria:nth-child(3) { animation-delay: 0.3s; }
.card-categoria:nth-child(4) { animation-delay: 0.4s; }
.card-categoria:nth-child(5) { animation-delay: 0.5s; }
.card-categoria:nth-child(6) { animation-delay: 0.6s; }
.card-categoria:nth-child(7) { animation-delay: 0.7s; }
.card-categoria:nth-child(8) { animation-delay: 0.8s; }

.card-categoria:hover {
  transform: translateY(-8px) scale(1.05);
  box-shadow: 0 12px 32px rgba(0, 242, 255, 0.4);
}

/* ✅ Efecto zoom al pasar el mouse sobre el icono */
.icono {
  width: 80px;
  height: 80px;
  margin-bottom: 1rem;
  object-fit: contain;
  transition: transform 0.4s ease;
}

.card-categoria:hover .icono {
  transform: scale(1.2) rotate(5deg);
}

.card-titulo {
  font-size: 1.2rem;
  font-weight: 700;
  margin-bottom: 0.5rem;
  text-align: center;
}

.card-descripcion {
  font-size: 0.95rem;
  text-align: center;
  line-height: 1.4;
}

/* Animaciones */
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@keyframes fadeInDown {
  from {
    opacity: 0;
    transform: translateY(-40px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
